import { render, staticRenderFns } from "./SetupSurveyQuestions.vue?vue&type=template&id=642bc30e&scoped=true&"
import script from "./SetupSurveyQuestions.vue?vue&type=script&lang=js&"
export * from "./SetupSurveyQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SetupSurveyQuestions.vue?vue&type=style&index=0&id=642bc30e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bc30e",
  null
  
)

export default component.exports